import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import EuLogoBar from "@/components/EuLogoBar";
import Logo from "@/components/Logo";
import { Footer } from "@/components/LandingPage";

const EFFECTS = [
  "rozpoczęcie działalności gospodarczej,",
  "utworzenie nowej firmy świadczącej usługi sprzątające,",
  "zakup niezbędnego wyposażenia i narzędzi,",
  "dotarcie z ofertą do klientów indywidualnych i firm,",
  "zwiększenie dostępności profesjonalnych usług sprzątających na lokalnym rynku.",
];

export default function Dofinansowanie() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <EuLogoBar />

      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-slate-100" data-testid="dofinansowanie-header">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[76px] flex items-center justify-between">
          <Link to="/" data-testid="dof-logo-home" className="shrink-0">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="dof-back-home"
            className="inline-flex items-center gap-2 text-[15px] font-medium text-slate-600 hover:text-cyan-600 transition-colors"
          >
            <ArrowLeft size={18} /> Strona główna
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <section className="bg-sky-50 py-16" data-testid="dofinansowanie-hero">
          <div className="max-w-4xl mx-auto px-5 sm:px-8">
            <span className="text-cyan-500 font-semibold uppercase tracking-[0.15em] text-sm">Fundusze Europejskie</span>
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-cyan-950 mt-3">
              Dofinansowanie
            </h1>
            <p className="text-slate-700 text-lg leading-relaxed mt-5">
              Firma LUSIIBŁYSK Lucyna Biegun otrzymała dofinansowanie na rozpoczęcie działalności
              gospodarczej w ramach projektu współfinansowanego ze środków Unii Europejskiej.
            </p>
          </div>
        </section>

        <section className="py-16" data-testid="dofinansowanie-content">
          <div className="max-w-4xl mx-auto px-5 sm:px-8 space-y-12">
            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Tytuł projektu</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Aktywizacja osób bezrobotnych zarejestrowanych w Powiatowym Urzędzie
                Pracy w Żywcu (II)
              </p>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Beneficjent</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                LUSIIBŁYSK Lucyna Biegun
              </p>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Źródło finansowania</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Projekt współfinansowany ze środków Unii Europejskiej w ramach programu:
              </p>
              <ul className="mt-2 text-slate-700 text-lg leading-relaxed">
                <li>Fundusze Europejskie dla Śląskiego 2021–2027</li>
                <li>Europejski Fundusz Społeczny Plus</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Wartość projektu i dofinansowania</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Wartość projektu: 30 000 zł
                <br />
                Wysokość dofinansowania: 30 000 zł
              </p>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Okres realizacji projektu</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Okres realizacji projektu: 29.04.2026 – 29.04.2027
              </p>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Krótki opis projektu</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Celem projektu jest rozpoczęcie i rozwój działalności gospodarczej firmy
                Lusi Błysk, świadczącej usługi sprzątające dla klientów indywidualnych oraz firm.
              </p>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                W ramach projektu zakupiono wyposażenie, narzędzia, materiały oraz usługi
                niezbędne do uruchomienia działalności gospodarczej i rozpoczęcia świadczenia
                usług sprzątających.
              </p>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">
                Projekt obejmuje również działania związane z przygotowaniem firmy do obsługi
                klientów, promocją działalności oraz budową obecności firmy w internecie.
              </p>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Zakładane efekty i korzyści</h2>
              <p className="text-slate-700 text-lg leading-relaxed mt-3">Realizacja projektu pozwala na:</p>
              <ul className="mt-4 space-y-3">
                {EFFECTS.map((e) => (
                  <li key={e} className="flex items-start gap-3">
                    <CheckCircle2 className="text-emerald-500 shrink-0 mt-1" size={20} />
                    <span className="text-slate-700 text-lg leading-relaxed">{e}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="font-heading font-bold text-2xl text-cyan-950">Hasztagi</h2>
              <p className="text-cyan-600 text-lg font-medium mt-3">#FunduszeUE #FunduszeEuropejskie</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
